import { useMemo } from 'react'

import { IconKey, SiteMap } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'

import { TopBarMenuLink } from '~/portal/components/TopBarMenuLink'
import { useAppConfig } from '~/shared/hooks/useAppConfig'
import { useEnvironment } from '~/shared/hooks/useEnvironment.ts'
import { Environment } from '~/shared/types/environment'

const getProfileLinks = ({ platformUiUrl, shubAppUrl, isOnPrem, platformManaged, swaggerhubOrgId }: { platformUiUrl: string, shubAppUrl: string, isOnPrem: boolean, platformManaged?: boolean, swaggerhubOrgId: string }) => [
  {
    icon: <SiteMap />,
    label: 'components.profile.buttons.myOrganizations.label',
    href: isOnPrem || !platformManaged ? `${shubAppUrl}/settings/organizations` : `${platformUiUrl}/organizations/${swaggerhubOrgId}/members`,
    isExternal: true
  },
  {
    icon: <IconKey width={16} height={16} />,
    label: 'components.profile.buttons.APIKey.label',
    href: `${shubAppUrl}/settings/apiKey`,
    isExternal: true
  },
]

export const ProfileSettings = ({ swaggerhubOrgId, platformManaged }: { swaggerhubOrgId: string, platformManaged?: boolean }) => {
  const { shubAppUrl, platformUiUrl } = useAppConfig()
  const env = useEnvironment()
  const profileLinks = useMemo(() => getProfileLinks({ platformUiUrl, shubAppUrl, isOnPrem: env === Environment.ON_PREM, platformManaged, swaggerhubOrgId }), [])

  const { t } = useTranslation()

  return <>
    <div className="mx-4 border-b border-b-(--sp-color-border-subtle)" />
    {profileLinks.map(profileLink => (
      <TopBarMenuLink key={t(profileLink.label)} icon={profileLink.icon} label={t(profileLink.label)} href={profileLink.href} isExternal={profileLink.isExternal} />)
    )}
  </>
}